import React, { memo } from 'react';
import { Text } from '@cuemath/web-comps';

import { ChipRow, ChipItem, ChipGroupField, FieldLabelText, UI } from '../../styled-comps';

// Chip selector. `options` = [{label, value}] (or plain values). Single-select
// when `multi` is false (value = scalar); multi-select returns an array —
// empty array means "all" for filter chips.
const ChipGroup = memo(({ label, options, value, onChange, multi }) => {
  const normalized = options.map(option =>
    typeof option === 'object' ? option : { label: String(option), value: option },
  );
  const selected = multi ? value || [] : [value];

  const toggle = chipValue => {
    if (multi) {
      const next = selected.includes(chipValue)
        ? selected.filter(item => item !== chipValue)
        : [...selected, chipValue];
      onChange(next);
    } else if (chipValue !== value) {
      onChange(chipValue);
    }
  };

  return (
    <ChipGroupField>
      {label && <FieldLabelText variant="eyebrow2">{label}</FieldLabelText>}
      <ChipRow>
        {normalized.map(option => {
          const isActive = selected.includes(option.value);
          return (
            <ChipItem key={option.value} $active={isActive} onClick={() => toggle(option.value)}>
              <Text variant="body3" color={isActive ? UI.card : UI.body}>
                {option.label}
              </Text>
            </ChipItem>
          );
        })}
      </ChipRow>
    </ChipGroupField>
  );
});

export default ChipGroup;
